export default __webpack_public_path__ + "static/media/nexus-logo.2216dcd7.jpeg";